import styled from "styled-components";

export const ServicesContainer = styled.div`
  /* border-top: solid black 6px; */
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* m  argin-top:100px; */
  /* background: rgb(1, 6, 6); */
  /* background: linear-gradient(0.25turn, #4c1109, #a0410f, #4c1109); */
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 255) 17%,
    rgba(9, 9, 121, 1) 39%,
    rgba(45, 38, 67, 1) 100%
  );
  @media screen and (max-width: 768px) {
    height: auto;
  }

  @media screen and (max-width: 480px) {
    height: auto;
  }
`;

export const Welcome = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: row;
  width: 100%;
  /* background: rgb(2, 0, 36); */
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
export const DirectionFlex = styled.div`
  flex-direction: row;
  text-align: center;
  width: 100%;
`;
export const Heading = styled.h1`
  /* margin-bottom: 24px; */
  text-align: center;
  font-size: 2.5vw;
  margin-top: 2%;
  display: inline-flex;
  color: white;
  font-family: "honeybear";
  line-height: 2.1;

  @media screen and (max-width: 480px) {
    font-size: 30px;
    justify-content: center;
    display: flex;
    line-height: 7rem;
    width: 100%;
    margin-bottom: 0px !important;
    margin-top: 20px;
  }
`;
export const MintBtnCont = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 60%;
  align-items: center;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between !important;
    width: 60%;
    align-items: center;
  }
`;
export const Heading1 = styled.span`
  margin-bottom: 24px;
  font-size: 64px;
  color: #e4a300;
  font-family: "Bangers", cursive;
  line-height: 1.1;
  font-weight: 600;
  @media screen and (max-width: 480px) {
    font-size: 30px;
  }
`;
export const Subtitle = styled.p`
  margin-bottom: 35px;
  font-size: 34px;
  line-height: 24px;
  font-family: "hellochristmas";
  color: white;
  @media screen and (max-width: 768px) {
    font-size: 20px;
    text-align: center;
    margin-right: 10px;
    margin-left: 10px;
  }
`;

export const SubtitleSpan = styled.span`
  margin-bottom: 35px;
  font-size: 34px;
  line-height: 24px;
  font-family: "Bangers", cursive;
  color: #00bec6;
  @media screen and (max-width: 768px) {
    font-size: 20px;
    text-align: center;
    margin-right: 10px;
    margin-left: 10px;
  }
`;

export const Subtitle1 = styled.p`
  font-size: 34px;
  line-height: 24px;
  font-family: "Bangers", cursive;
  color: #e4a300;
  @media screen and (max-width: 768px) {
    font-size: 20px;
    text-align: center;
    margin-right: 10px;
    margin-left: 10px;
  }
`;
export const MintingButton = styled.img`
  /* width: 41%; */
  height: 50px;
  width: 13%;
  margin-top: 2%;
  border-radius: 11px;
  margin-bottom: 2%;
  border: 4px solid #828;
  @media screen and (max-width: 767px){
    width: 29%;
  }
`;

export const NavBtnLink1 = styled.button`
  /* width: 100%; */
  border-radius: 50px;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
  background: #828;
  height: 60px;
  white-space: nowrap;
  padding: 0px 22px;
  color: white;
  font-size: 38px;
  /* margin-top: -96px; */
  font-family: "AgencyBold";
  outline: none;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  /* &:hover {
    transition: all 0.2s ease-in-out;
    background: linear-gradient(to right, red, yellow);
    color: black;
  } */
  @media screen and (max-width: 768px) {
    font-size: 19px;
    width: 100%;
    padding: 0px 22px;
    height: 56px;
  }
`;
export const Input2 = styled.input`
  height: 60px;
  pointer-events: none;
  width: 100%;
  border: 4px solid #828;
  font-size: 30px;
  text-align: center;
  font-weight: bold;
  &.focus-visible {
    outline: none;
  }
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;
export const NavBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 15vh;
  width: 23%;
  @media screen and (max-width: 768px) {
    height: 10vh;
  }
`;
export const Subtitle1Span = styled.span`
  font-size: 34px;
  line-height: 24px;
  font-family: "Bangers", cursive;
  color: #e4a300;
  @media screen and (max-width: 768px) {
    font-size: 30px;
    text-align: center;
    margin-right: 10px;
    margin-left: 10px;
  }
`;
export const addMargin = styled.div`
  margin-top: 16px;
  @media screen and (max-width: 768px) {
    margin-top: 13px;
  }
`;
export const Welcomeimg = styled.img`
  width: 35%;
  @media screen and (max-width: 768px) {
    width: 60%;
  }
`;
